import styled from "styled-components";

const FailureWrapper = styled.div`
	.main-container {
      background: white;
      border-radius: 12px;
      padding-right: 0px !important;
      padding-left: 0px !important;
      display: flex;
      justify-content: center;
      flex-direction: column;
	}
	.failure-img-container {
		.failure-img {
			margin-top: 88px;
		}
	}
	.failure-header {
      font-size: 34px;
      font-weight: 800;
      color: black;
      padding: 0px 20px 0px 20px;
	}
	.failure-body {
      text-align: center;
      color: #455560;
      padding: 0px 20px 0px 20px;
	}
	.p-button {
		background: #6B47F5;
		border: none !important;
	}
	.p-button:hover {
		background: #6B47F5;
		border: none !important;
	}
	.contact-us-img {
		margin-right: 8px;
	}
	.back-text {
		color: #6B47F5;
		margin-left: 8px;
	}
	.btn-sec {
		margin-top: 40px;
		margin-bottom: 60px;
	}
	.left-btn {
		margin-right: 40px;
		cursor: pointer;
	}
	.social-card4 {
		border-top-right-radius: 12px;
		border-top-left-radius: 12px;
		border: none;
		-webkit-box-shadow: 0 0 2px #fff;
		box-shadow: 0 0 2px #fff;
		background: black;
		height: auto;
		color: #ffff;
		padding: 15px 20px !important;
		margin-top: 0px !important;

		.mainBannerPara {
			font-weight: 400;
			font-size: 0.9rem;
			line-height: 14px;
			color: #ffffff;
		}

		.mainBannerPara2 {
			font-weight: 400;
			font-size: 0.9rem;
			line-height: 14px;
			color: black;
		}

		.chat_width {
			width: 170px;
		}

		.mainBannerHeading {
			font-weight: 700;
			font-size: 0.9rem;
			line-height: 20px;
			color: #ffffff;
		}

		.mainBannerHeading2 {
			font-weight: 700;
			font-size: 1.05rem;
			line-height: 20px;
			color: black;
		}

		.mainBannerHeading2_email {
			cursor: pointer;
		}

		.hrtag {
			opacity: 0.1;
			border: none !important;
			border-top: 1px solid #ffffff !important;
		}

		.hrtag2 {
			opacity: 0.1;
			border: none !important;
			border-top: 1px solid black !important;
			background: black;
		}
		.bottom-sec-details {
			width: 76%;
			justify-content: space-between;
		}
	}
`;

export default FailureWrapper;
